import type { ReactElement } from "react";
import U2001 from "./U2001";
import U2001Login from "./components/U2001Login";
import U2001GoogleReturn from "./components/U2001GoogleReturn";

interface RouteObject {
  path?: string;
  element?: ReactElement;
  index?: boolean;
  children?: RouteObject[];
}

const U2001Routes: RouteObject[] = [
  {
    path: "U2001",
    element: <U2001 />,
    children: [{ index: true, element: <U2001Login /> }],
  },
  {
    path: "login/google/return",
    element: <U2001 />,
    children: [{ index: true, element: <U2001GoogleReturn /> }],
  },
];

export default U2001Routes;
